import React from 'react';
import { FlattenSimpleInterpolation } from 'styled-components';
import Lang from '@lang/en';
import { StyledLoader } from './styles';
interface PropsInterface {
  className?: string;
  extraStyle?: FlattenSimpleInterpolation;
}

const Loader: React.FC<PropsInterface> = ({ className, extraStyle }) => {
  return (
    <StyledLoader
      className={`loader d-flex justify-content-center ${className}`}
      extraStyle={extraStyle}
      data-testid="loader"
    >
      <div className="spinner-border text-primary" role="status">
        <span className="sr-only">{Lang.loadingMessage}</span>
      </div>
    </StyledLoader>
  );
};

export default Loader;
